module.exports = __webpack_public_path__ + "static/media/132.18bca2fc.webp";